export default __webpack_public_path__ + "static/revolving_door_b.e248e48874e66f7e3c77af601cd9bbf0.svg";